import React, { Component } from "react";
import Modal from "../../app/UI/Modal/Modal";
import { connect } from "react-redux";

import { closeModal } from "./modalActions";
import RegisterComputer from "../merchants/Merchant/MerchantProfile/Outlets/Outlet/Computers/RegisterComputer";

const actions = { closeModal };

const registerMechantComputerModal = ({ closeModal }) => {
  return (
    <Modal modalHeader="Register Merchant Device" onClose={closeModal}>
      <RegisterComputer />
    </Modal>
  );
};

export default connect(
  null,
  actions
)(registerMechantComputerModal);
